module.exports = __webpack_public_path__ + "static/media/ep3.09a4ed74.jpg";